import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "pt-6"
}
const _hoisted_3 = {
  key: 1,
  class: "pt-6"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _cache[8] || (_cache[8] = _createElementVNode("h2", null, "グループ設定", -1)),
        _createVNode(_component_v_spacer),
        _createVNode(_component_v_btn, {
          onClick: _ctx.clickCreateBtn,
          color: "primary",
          variant: "flat"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, { start: "" }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode("mdi-plus", -1)
              ]))]),
              _: 1
            }),
            _cache[7] || (_cache[7] = _createTextVNode(" グループ作成 ", -1))
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "3",
          class: "pl-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field, {
              modelValue: _ctx.searchFilters.year,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchFilters.year) = $event)),
              suffix: "年度",
              label: "年度",
              type: "number",
              "hide-details": "",
              variant: "outlined",
              density: "compact"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "9",
          "align-self": "center"
        }, {
          default: _withCtx(() => [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(_component_v_progress_circular, {
                    color: "primary",
                    indeterminate: ""
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.groups.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_v_list, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (item, i) => {
                return (_openBlock(), _createBlock(_component_v_list_item, {
                  key: i,
                  class: "pa-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      onClick: ($event: any) => (_ctx.clickItem(item)),
                      variant: "outlined",
                      link: "",
                      width: "100%",
                      color: "grey"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_text, { class: "text-black" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "6" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.name), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_col, { cols: "3" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.year + "年度"), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_col, { cols: "3" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString("作成日: " + _ctx.formatDate(item.createdAt)), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[9] || (_cache[9] = [
          _createElementVNode("h5", null, "グループはありません", -1)
        ]))])),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dialog,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dialog) = $event)),
      "max-width": "620px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.isEdit ? "グループ設定" : "グループ作成"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_container, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { align: "center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                            _createElementVNode("div", null, "対象年度", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.group.year,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.group.year) = $event)),
                              type: "number",
                              suffix: "年度",
                              variant: "outlined",
                              "hide-details": "",
                              density: "compact"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, { align: "center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                            _createElementVNode("div", null, "グループ名", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.group.name,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.group.name) = $event)),
                              variant: "outlined",
                              "hide-details": "",
                              density: "compact"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_container, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialog = false)),
                          color: "grey",
                          text: ""
                        }, {
                          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                            _createTextVNode(" キャンセル ", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_v_spacer),
                        (_ctx.isEdit)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 0,
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.deleteGroup())),
                              loading: _ctx.loading,
                              class: "mr-2",
                              color: "error",
                              variant: "flat"
                            }, {
                              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                _createTextVNode(" 削除 ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["loading"]))
                          : _createCommentVNode("", true),
                        (_ctx.isEdit)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 1,
                              onClick: _ctx.updateGroup,
                              loading: _ctx.loading,
                              color: "primary",
                              variant: "flat"
                            }, {
                              default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                _createTextVNode(" 保存 ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["onClick", "loading"]))
                          : (_openBlock(), _createBlock(_component_v_btn, {
                              key: 2,
                              onClick: _ctx.createGroup,
                              loading: _ctx.loading,
                              color: "primary",
                              variant: "flat"
                            }, {
                              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                _createTextVNode(" 作成 ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["onClick", "loading"]))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}